<div *ngIf="company.is_template" class="template-alert">
  ¡ATENCIÓN! ESTÁS CONECTADO A UNA PLANTILLA.
</div>
<div class="layout-topbar-backdrop">
  <div class="layout-topbar">
    <p-overlayPanel #op appendTo="body">
      <ng-template pTemplate>

        <div style="min-width: 300px;" *ngIf="personalize_interface || views_superadmin">
          <label><small>¿Qué vista quiere mostrar?</small></label><br />
          <p-dropdown [options]="dropdownViews" [(ngModel)]="selectedView" optionLabel="name" optionValue="id"
                      [filter]="true" filterBy="name" class="p-field" *ngIf="personalized_views_read" appendTo="body"
                      placeholder="Selecciona una vista" (onChange)="changeCurrentView()">
            <ng-template pTemplate="selectedItem">
              <div class="view-item">
                <div><i class="fa fa-thumbtack p-mr-1"></i> {{view.name}} </div>
              </div>
            </ng-template>
            <ng-template let-view pTemplate="item">
              <div style="display:flex;align-items:center;">
                <div style="margin-right: 5px;">
                  <i class="fa fa-thumbtack p-mr-1" *ngIf="view.id == selectedView"></i>
                </div>
                <div>
                  <div *ngIf="view.id != -1">
                    {{view.name}} <span style="font-size: 11px; color: #7b918d" *ngIf="view.metadata?.default == true">
                      (por defecto)
                    </span>
                  </div>
                  <div *ngIf="view.id == -1 && personalized_views_write" class="p-text-center">
                    <p-button label="Añadir nueva vista" icon="pi pi-plus" styleClass="p-ml-2 p-block"
                              (click)="newView(false); event.preventDefault()"></p-button>
                  </div>
                  <div *ngIf="view.id > 0" style="color: #a1b6b2">
                    <small>
                      {{
                      view.user?.name ? 'Creada por: '+
                      view.user.name : "Vista del
                      sistema"
                      }}
                      <div *ngIf="view.updatedBy?.name">
                        {{view.updatedBy?.name ? 'Últ. Modificación: '+view.updatedBy.name:""}}
                        {{view.updated_at | date: '(dd/MM/yyyy HH:mm)':'GMT'}} {{view.updated_at ? '' : ''}}
                      </div>
                    </small>
                  </div>
                </div>
              </div>

            </ng-template>
          </p-dropdown>
        </div>
        <br />

        <div *ngIf="(view.id && view.user_id == created_by && personalize_interface) || (view.user_id && views_superadmin) || (views_superadmin && company.is_template)">
          <label><small>¿Desea configurar la existente?, modifíquela</small></label>
          <br />
          <a class="p-button p-mt-2" *ngIf="personalize_interface" (click)="editViewClick(false)">Modificar vista</a>
        </div>
        <div *ngIf="!((view.id && view.user_id == created_by && personalize_interface) || (view.user_id && views_superadmin) || (views_superadmin && company.is_template))">
          <label><small><i class="pi pi-exclamation-triangle"></i>Tú no puedes modificar esta vista.</small></label>
        </div>
        <br />
        <label *ngIf="personalize_interface || views_superadmin"><small>¿Quieres crear una nueva?</small></label>
        <br />
        <a class="p-button p-mt-2" *ngIf="personalize_interface || views_superadmin" (click)="newView()">
          Añadir nueva
          vista
        </a>

      </ng-template>
    </p-overlayPanel>

    <div class="p-d-flex p-jc-between">

      <div class="p-d-flex p-ai-center ">
        <div class="layot-topbar-menu-button">
          <a (click)="toogleMenu()" style="margin-right: 10px;">
            <fa-icon [icon]="['fas', 'bars']"></fa-icon>
          </a>
        </div>
        <div class="p-d-flex p-ai-center searchbox">
          <label for="data_type">
            <i class="pi pi-search"></i>
          </label>
          <p-autoComplete [(ngModel)]="searchText" placeholder="Busca una organización, contacto, tarea ..."
                          [suggestions]="searchResults" class="topAutoComplete" (completeMethod)="filterSearch($event)" field="text"
                          (onSelect)="viewElementDetail($event)" minLength="3">
            <ng-template let-result pTemplate="item">
              <div class="result-item" style="display:flex;align-items:center">
                <div style="margin-right: 8px;"><i class="{{result.icon}}"></i></div>
                <div>
                  <div style="font-size: 15px;" [highlight]="searchText" [inputText]="result.text"
                       customClasses="bg-transparent font-semibold color-green-axial">{{result.text}}</div>
                  <div style="color:#909090;font-size: 11px" *ngIf="result.moreInfo" [highlight]="searchText"
                       [inputText]="result.moreInfo" customClasses="bg-transparent font-semibold color-green-axial">
                    {{result.moreInfo}}
                  </div>
                </div>
              </div>
            </ng-template>
          </p-autoComplete>
        </div>
      </div>
      <div class="p-d-flex p-ai-center quick-actions">

        <div *ngFor="let item of itemsQuickMenu" class="ablockHeaderHome" pTooltip="{{item.label}}"
             tooltipPosition="bottom">
          <a (click)="call(item)" *ngIf="item.visible && item.value == 0">
            <div class="icon"><i class="{{item.icon}}"></i></div>
          </a>
          <a (click)="call(item)" *ngIf="item.visible && item.value > 0">
            <div class="icon"><i class="{{item.icon}} p-badge-danger" pBadge value="{{item.value}}"></i></div>
          </a>
        </div>
        <div class="ablockHeaderHomeMOBILE vl"></div>
        <div class="ablockHeaderHomeMOBILE">
          <a (click)="options.toggle($event)"><i class=" pi pi-chevron-down"></i></a>
        </div>

        <div class="vl"></div>

        <a (click)="quickAddOrganization()" pTooltip="Creación rápida" tooltipPosition="bottom">
          <i pbadge="" value="2" class="pi pi-plus-circle"></i>
        </a>
        <div class="vl"></div>


        <a (click)="menu.toggle($event)">
          <div class="user-dropdown p-d-flex">
            <img src="{{imageUrl}}" style="height: 40px; width: 40px; margin-left: 0px; margin-right: 5px;" />

            <div class="no-mobile" style="text-align: left;">
              <b>{{user.name}}</b><br>
              <small>{{user.companyName}} - Nº. {{companyCode}}</small>
            </div>
          </div>
        </a>
        <div class="no-mobile vl"></div>

        <a class="no-mobile" (click)="op.toggle($event)"
           *ngIf="(allowViewPersonalize && personalized_views_write && personalize_interface) || (allowViewPersonalize && views_superadmin)"
           pTooltip="Configurar" tooltipPosition="top">
          <fa-icon [icon]="['fas','cog']" style="color: #6e6b7b"></fa-icon>
        </a>
        <div class="no-mobile vl" *ngIf="allowViewPersonalize && personalized_views_write && personalize_interface">
        </div>
      </div>
    </div>
  </div>
  <p-slideMenu #menu [model]="items" [popup]="true" appendTo="body" styleClass="slideMenuTopbar"></p-slideMenu>
  <p-slideMenu #options [model]="itemsQuickMenu" [popup]="true" appendTo="body" styleClass="slideMenuTopbar"></p-slideMenu>
</div>
